module.exports = __webpack_public_path__ + "img/gluten-corner-transparent.6b967e12.png";